import { useState, useEffect } from "react";

const useConferenceDuration = (isJoined) => {
    const [startTime, setStartTime] = useState(null);
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        let interval;

        if (isJoined) {
            if (!startTime) {
                setStartTime(Date.now()); // Store when the call started
            }

            interval = setInterval(() => {
                setDuration(Math.floor((Date.now() - (startTime || Date.now())) / 1000));
            }, 1000);
        } else {
            clearInterval(interval);
            setStartTime(null);
            setDuration(0);
        }

        return () => clearInterval(interval);
    }, [isJoined, startTime]);

    return duration;
};

export default useConferenceDuration;